import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    listarRegrasEnvio() {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("regrasEnvio/access/listar").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    obterRegraEnvio(context, idConfiguracaoEnvio) {
        return new Promise((resolve) => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("regrasEnvio/access/obter", { ID_CONFIGURACAO_ENVIO: idConfiguracaoEnvio }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    processarRegraEnvio(context, idConfiguracaoEnvio) {
        return new Promise((resolve) => {
            if(JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("regrasEnvio/access/processar", { ID_CONFIGURACAO_ENVIO: idConfiguracaoEnvio }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    excluirRegraEnvio(context, idConfiguracaoEnvio) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("regrasEnvio/access/excluir", { ID_CONFIGURACAO_ENVIO: idConfiguracaoEnvio }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async salvarRegraEnvio(context, dados) {
        if (!JwtService.getToken()) throw new Error('Entre novamente para salvar a regra.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('regrasEnvio/access/salvar', dados);
        return data;
    },
    async reavaliarOcorrenciaRegraEnvio(context, id) {
        if (!JwtService.getToken()) throw new Error('Entre novamente para reavaliar a pendência.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('regrasEnvio/access/reavaliarOcorrencia', { ID_PAY_AUTOMACAO: id });
        if (!data?.estado) throw new Error(data?.erro || 'Não foi possível reavaliar a pendência.');
        return data;
    },
    async obterOcorrenciasRegraEnvio(context, id) {
        if (!JwtService.getToken()) throw new Error('Entre novamente para consultar os processamentos.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('regrasEnvio/access/ocorrencias', { ID_CONFIGURACAO_ENVIO: id });
        if (!Array.isArray(data)) throw new Error(data?.msg || data?.erro || 'Não foi possível consultar os processamentos.');
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
